import { cn } from "@gettactic/helpers/src/css/cn";
import React from "react";
import { FormControlWrapper } from "../FormControlWrapper";
import {
  useFormControlInputA11y,
  useFormControlWrapper
} from "../FormControlWrapper/FormControlWrapperProvider";
import { splitFormControlWrapperProps } from "../FormControlWrapper/helpers";
import {
  TextEditorInputProps,
  TextEditorInputPropsWithFormControl
} from "./TextEditorInput.types";
import { TextEditor } from "./TextEditor";

export const TextEditorInputInput: React.FC<TextEditorInputProps> = (props) => {
  const { className, disabled, contentClassName, ...rest } = props;
  // Named and described by the field around it
  const { label } = useFormControlWrapper();
  const { "aria-describedby": ariaDescribedBy } = useFormControlInputA11y();
  return (
    <div className={cn(className)}>
      <TextEditor
        {...rest}
        disabled={disabled}
        contentClassName={contentClassName}
        ariaLabel={typeof label === "string" ? label : undefined}
        ariaDescribedBy={ariaDescribedBy}
      />
    </div>
  );
};

TextEditorInputInput.displayName = "TextEditorInputInput";

/**
 * A rich text field (Tiptap) with a formatting toolbar and a link dialog. `value` and
 * `onChange` use HTML; `onChange` receives `null` when the text is emptied. Use
 * `formatting="basic"` for content rendered through a strict tag allow-list. Inside
 * react-hook-form use `HookFormTextEditorInput`.
 */
export const TextEditorInput = React.forwardRef<
  HTMLDivElement,
  TextEditorInputPropsWithFormControl
>((props, ref) => {
  const [wrapperProps, inputProps] = splitFormControlWrapperProps(props);

  return (
    <FormControlWrapper variant={"unstyled"} {...wrapperProps}>
      <div className={"w-full"} ref={ref}>
        <TextEditorInputInput {...inputProps} />
      </div>
    </FormControlWrapper>
  );
});

TextEditorInput.displayName = "TextEditorInput";
